import assets from '../../journey/assets';
import { AssetContext } from '@artica/assets';

const keys = Object.keys(assets.preload);

export default function PreloadAssetContext({ children }) {
  return (
    <AssetContext keys={ keys }>
      { children }
    </AssetContext>
  );
};